import { Flex } from "@chakra-ui/react";
import { Spinner } from "@chakra-ui/spinner";
import React from "react";

const Loader = (props: { size?: string }) => {
  return (
    <Flex justify="center" align="center" w='100%' h='100%'>
      <Spinner size={props.size ? props.size : "xl"} />
    </Flex>
  );
};

export default Loader;
